<template>
  <div class="wrapper w-100">
    <div class="accordion w-100" @click="toggle">
      <button class="title d-flex btn text-secondary font-weight-bold configurator-nav py-2 px-2 mb-1 w-100 justify-content-between rounded-0">
        <span><slot name="title"></slot></span>
        <i class="mt-1 fas" :class="[ show ? `fa-chevron-up`: `fa-chevron-down` ]"></i>
      </button>
    </div>
    <div class="content" ref="content" v-show="show">
      <p class="">
        <slot name="content"></slot>
      </p>
    </div>
  </div>
</template> 

<script>
import { TweenLite, CSSPlugin } from 'gsap'

// eslint-disable-next-line
const plugins = [CSSPlugin]

export default {
  data() {
    return {
      show: false,
    }
  },
  props: {
    id: {
      type: String,
      default: null
    }
  },
  methods: {
    toggle() {
      if (!this.show) {
        this.show = !this.show
        TweenLite.set(this.$refs.content, { height: 'auto', opacity: 1})
        TweenLite.from(this.$refs.content, .2, { height: 0})
      } else {
        TweenLite.set(this.$refs.content, { opacity: 0 })
        TweenLite.to(this.$refs.content, .2, { height: 0, onComplete: () => {
          this.show = !this.show
        }})
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  height: 0px;
  opacity: 0;
}
</style>